import axios from 'axios';
import { API_CONFIG } from '../config/config';

// Determine API base URL based on environment
const getApiBaseUrl = () => {
  // Use centralized configuration
  return API_CONFIG.BASE_URL;
};

// Create an instance of axios with default config
const apiClient = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: API_CONFIG.TIMEOUT,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add a request interceptor to attach the token to authenticated requests
apiClient.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle common API response scenarios
apiClient.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    // Handle authentication errors (401)
    if (error.response && error.response.status === 401) {
      // If we get a 401 response, the token might be expired
      // Clear the stored token and user info
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      // Optionally redirect to login page
      // window.location.href = '/login';
    }
    
    return Promise.reject(error);
  }
);

export default apiClient;
